import { render, staticRenderFns } from "./LanguageVisitorSettingView.vue?vue&type=template&id=da389f5c&scoped=true&"
import script from "./LanguageVisitorSettingView.vue?vue&type=script&lang=js&"
export * from "./LanguageVisitorSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da389f5c",
  null
  
)

export default component.exports